// Material Symbol name for a course's delivery mode. No in-person courses
// exist yet, so the icon is picked by keyword rather than a dedicated
// content field — swap for an explicit field if a future course needs a
// mode this heuristic can't classify correctly. Shared by TrainingCard
// (listing) and TrainingDetail (course page) so both render the same icon
// for the same mode text.
export function trainingModeIcon(mode) {
  return /in-person|on campus|face-to-face/i.test(mode || '') ? 'location_on' : 'computer'
}
